import { render } from "./TableDialogData.vue?vue&type=template&id=2e86fcf7"
import script from "./TableDialogData.vue?vue&type=script&lang=js"
export * from "./TableDialogData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__